import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles(theme => ({
  root: {
    height: "0vh",
    width: "0vw",
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fefefe",
    zIndex: 899
  },
  show: {
    height: "100vh",
    width: "100vw"
  },
  container: {
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "50%"
    }
  },
  img: {
    width: "100%",
    marginBottom: "1vw"
  }
}));

const Loading = ({ show }) => {
  const classes = useStyles();
  return (
    <div className={show ? clsx(classes.root, classes.show) : classes.root}>
      <div className={classes.container}>
        <img
          className={classes.img}
          src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`}
          alt="Cargando..."
        />
        <LinearProgress className="mt-2" />
      </div>
    </div>
  );
};

export default Loading;
